jQuery(document).ready(function(){
    jQuery(document).on('click, touchstart', '.mobile-menu-trigger--initial', function(){
        jQuery('.mobile-menu-bg').removeClass('mobile-menu-bg--hidden');
        jQuery(this).removeClass('mobile-menu-trigger--initial').addClass('mobile-menu-trigger--close');
        jQuery('.mobile-menu-container').addClass('mobile-menu-container--show');
        jQuery('header').addClass('headroom--menu-open');
        setTimeout(function(){
            disableScroll();
        }, 100);
    });
    jQuery(document).on('click, touchstart', '.mobile-menu-trigger--close', function(){
        jQuery('.mobile-menu-bg').addClass('mobile-menu-bg--hidden');
        jQuery('.mobile-menu-container').removeClass('mobile-menu-container--show');
        jQuery(this).removeClass('mobile-menu-trigger--close').addClass('mobile-menu-trigger--initial');
        jQuery('.mobile-sub-category-dropdown-container').removeClass('active');
        jQuery('.select2').trigger("select2:close");
        jQuery('header').removeClass('headroom--menu-open');
        enableScroll();
    });
    jQuery("header").headroom({
        offset : 104
    });

    /* check if first atom is an image, so we can set the color of the mobile menu */
    if(jQuery('main .atomic-container:first-of-type').attr('class').indexOf('hero-image') === -1){
        jQuery('.mobile-menu-trigger').addClass('black-menu');
    }

    jQuery('.mobile-language-picker').click(function(){
        jQuery('.mobile-language-picker .lang-dropdown').toggleClass('active');
    });

    jQuery('.language-picker.desktop').click(function(){
        jQuery('.language-picker.desktop .lang-dropdown').toggleClass('active');
    });
});

function disableScroll() {
    var scrolled = jQuery(window).scrollTop();
    jQuery('body').data('scrolled', scrolled);
    jQuery('body').css({'position': 'fixed',
    'top': '-' + scrolled + 'px',
    'left': '0px',
    'width': '100%',
    'overflow-y': 'scroll'});
}

function enableScroll() {
    jQuery('body').css({'position': 'relative',
    'top': 'auto',
    'left': 'auto',
    'overflow': 'auto'});
    window.scrollTo(0, jQuery('body').data('scrolled'));
}
